export const BottomLeft = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="0.5"
        width="19"
        height="19"
        rx="3.5"
        stroke="var(--dark)"
      />
      <rect
        x="2.23047"
        y="11.6155"
        width="6.15385"
        height="6.15385"
        rx="2"
        fill="var(--dark)"
      />
    </svg>
  );
};
